import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'src/components/Image/Image';

const Icon = props => {
	const { className, onClick, icon, style, url, lazyLoad = false, noDefaultStyles = false } = props;
	const urlIcon =
    url || `https://storage.cloud.google.com/bucket.shoppingapps.me/images/fs-icons/${icon}.svg?organizationId=918228201194`;
	const imgStyles = noDefaultStyles ? {} : { width: '25px', height: '25px' };
	return <Image url={urlIcon} onClick={onClick} customStyles={{ ...imgStyles, ...style }} className={className} lazyLoad={lazyLoad} />;
};

Icon.propTypes = {
	style: PropTypes.object,
	onClick: PropTypes.func,
	size: PropTypes.string,
	className: PropTypes.string,
	url: PropTypes.string,
};

Icon.defaultProps = {
	style: {},
	onClick: null,
	size: '',
	className: '',
	url: null,
};

export default Icon;
